export default {
  props: {
    params: {
      data: Object,
      type: Object,
      showAnimation: Boolean,
      default: () => ({
        type: 'black',
        arrow: true,
        showAnimation: false,
      }),
    },
  },
  data () {
    return {
      currentPage: null,
      firstPage: null,
      lastPage: null,
      firstPageUrl: null,
      lastPageUrl: null,
      from: null,
      to: null,
      prevPage: null,
      nextPage: null,
      perPage: null,
      total: null,
      url: null,
      currentCount: null,
      listPage: [],
      maxShow: 5,
      allOverview: false,
    };
  },
  computed: {
    showFirstDots () {
      return (this.currentPage - 1 >= 1 && this.listPage[0] != 1 && this.lastPage > 2);
    },
    showLastDots () {
      return (this.listPage[this.listPage.length - 1] < this.lastPage && this.lastPage > 2);
    },
  },
  created () {
    this.moveToPaginate(this.params.data);
  },
  methods: {
    moveToPaginate (data) {
      if (!Object.keys(data).length) {
        this.lastPage = 0;
        return;
      }

      this.currentCount = data.Data.length;
      this.currentPage = data.CurrentPage;
      this.firstPage = data.From;
      this.lastPage = data.LastPage;
      this.firstPageUrl = data.FirstPageUrl;
      this.lastPageUrl = data.LastPageUrl;
      this.from = data.From;
      this.to = data.To;
      this.perPage = data.PerPage;
      this.total = data.Total;
      this.url = data.URL;

      if (this.currentPage == 1) {
        this.prevPage = null;
      }
      if (this.currentPage != 1) {
        this.prevPage = this.currentPage - 1;
      }
      if (this.currentPage == this.lastPage) {
        this.nextPage = null;
      }
      if (this.currentPage < this.lastPage) {
        this.nextPage = this.currentPage + 1;
      }

      if (this.listPage.length === 0) {
        for (let i = this.firstPage; i <= this.lastPage; i++) {
          this.listPage.push(i);
        }
        if (this.lastPage - this.firstPage >= 5) {
          let from = this.currentPage - 1;
          let to = this.lastPage;

          if (from >= 1) {
            from = from - 1;
          }
          if (to > 5) {
            to = to - (to - from) + 4;
          }
          if (this.currentPage >= this.lastPage - 2) {
            from = this.lastPage - 4;
          }
          this.listPage = this.listPage.slice(from, to);
        }
      }
    },
    showAllPages () {
      this.allOverview = !(this.params.data.PerPage === this.total);
      this.$emit('getAllPages', this.total, this.allOverview);
    },
    paginate (page) {
      this.$emit('changePaginate', page, this.total);
    },
    paginateCircle (page) {
      if (this.params.showAnimation) {
        return;
      }
      this.$emit('changePaginate', page, this.total);
    },
  },
};
